import * as React from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import PropTypes from "prop-types";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      minHeight: ITEM_HEIGHT,
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 200,
    },
  },
};

function getStyles(theme) {
  return {
    fontWeight: theme.typography.fontWeightRegular,
    //   : theme.typography.fontWeightMedium,
  };
}

export default function MultipleSelectChip({ label, data, onChange }) {
  const theme = useTheme();
  const [valuesToShow, setvaluesToShow] = React.useState([]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setvaluesToShow(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
    onChange(value);
  };

  return (
    <div>
      <FormControl sx={{ m: 1, width: 300 }}>
        <InputLabel id="demo-multiple-chip-label">{label}</InputLabel>
        <Select
          style={{ minHeight: "48px", marginLeft: "-8px" }}
          labelId="demo-multiple-chip-label"
          id="demo-multiple-chip"
          multiple
          value={valuesToShow}
          onChange={handleChange}
          input={<OutlinedInput id="select-multiple-chip" label={label} />}
          renderValue={(selected) => (
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
              {selected.map((value) => (
                <Chip key={value} label={getValueByKey(value, data)} />
              ))}
            </Box>
          )}
          MenuProps={MenuProps}
          inputProps={{
            IconComponent: () => (
              <ExpandMoreIcon
                style={{
                  marginRight: "5px",
                  pointerEvents: "none",
                  position: "absolute",
                  right: "10px",
                }}
              />
            ),
          }}
        >
          {data.map((elem) => (
            <MenuItem key={elem.key} name={elem.value} value={elem.key} style={getStyles(theme)}>
              {elem.value}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}

function getValueByKey(key, dataList) {
  return dataList.filter((elem) => elem.key === key)[0].value;
}

const names = [
  { key: 1, value: "Oliver Hansen" },
  { key: 2, value: "Jon Snow" },
];

MultipleSelectChip.defaultProps = {
  label: "Chips",
  data: names,
};

MultipleSelectChip.propTypes = {
  label: PropTypes.string,
  data: PropTypes.array,
  onChange: PropTypes.func,
};
